import { useEffect, useState } from "react";
import { Col, Form, Row} from "react-bootstrap";
import { ToastService } from "../../../services/toast.service";
import { HeaderList } from "../../../components/HeaderList";
import { DatasetDefault, DatasetModel } from "../../../models/dataset.model";
import { useTranslation } from 'react-i18next';
import {
  RequestInputOutputParamsModelDefault,
  RequestInputOutputParamsModel
} from "../../../models/requestInputOutputParams.model";
import _ from 'lodash';
import moment from 'moment';
import storageService from "../../../services/storage.service";
import styled from "styled-components";
import { DropdownButtonExport } from "../../../components/dropdownButton";
import { FileExportService } from "../../../services/fileExport.service";

const Styles = styled.div`
  .react-datepicker-wrapper {
    width: 100%
  }
`;

const IndicatorList = () => {

  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const user = storageService.getUser();
  const [dataOptions, setDataOptions] = useState<{ value: Date; label: string }[]>([]);

  const [selectedDate, setSelectedDate] = useState("");
  const [dateCombo, setDateCombo] = useState("");
  const [selectedDateRef, setSelectedDateString] = useState(new Date());

  const [dataSet, setDataset] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)),
    dataset: 'dashboard_core',
    filters: {},
    pagination: {
        page_number: 1,
        total_pages: 1,
        records_pages: 100,
        total_records: 0
    },
  });

  
  const idiom = storageService.getIdiom();
  const checkExportOk = () => {
    if (selectedDate == "")
    {
      ToastService.warn(t("DATE_NEEDED_SELECT"), null);
      return false;
    }
    return true;
  };

  useEffect(() => {
    const now = new Date();
    const months: { value: Date; label: string }[] = [];
    const formatter = new Intl.DateTimeFormat(t("DATETIMEFORMAT"), { month: "short", year: "numeric" });


    for (let i = 0; i < 24; i++) {
      const d = new Date(now.getFullYear(), now.getMonth() - i, 1);

      let label = formatter.format(d)
        .replace(/\./g, "")    // remove pontos
        .replace(" de ", "/"); // troca " de " por "/"

      label = label.charAt(0).toUpperCase() + label.slice(1);

      months.push({ value: d, label });
    }

    setDataOptions(months);
  }, []);
  

  const getDataSet = (d) => {
    let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [dataSet] };
    requestParams.datasets[0].filters.date = d;
    return requestParams;
  }

  return (
    <>
    <Styles>
      <HeaderList title={t(`MENU_INDICATOR_EXCEL`)} />
      <Form>
        <Form.Label className="mb-0">{t("FILTERS")}</Form.Label>
        <Row className='mt-3'>
          <Col sm={12} md={6} lg={3}>
          <Form.Group>
              <Form.Floating>
                <Form.Control
                  as='select'
                  className='form-control'
                  value={dateCombo}  
                  onChange={(e) => {
                    if (e.target.value == "")
                    {
                      setSelectedDate("");
                      setDateCombo(e.target.value);
                    }
                    else
                    {
                      let id = moment(e.target.value).toDate().getDate().toString();
                      const d = new Date(e.target.value);

                          // yyyy-mm-dd
                      const yyyy = d.getFullYear();
                      const mm = (d.getMonth() + 1).toString().padStart(2, "0");
                      const dd = d.getDate().toString().padStart(2, "0");

                      const formatted = `${yyyy}-${mm}-${dd}`;

                      setSelectedDate(formatted);
                      setSelectedDateString(moment(e.target.value).toDate());
                      setDateCombo(e.target.value);
                    }                    
                  }}               
                >
                  <option value=''>{t("FILTER.SELECT")}</option>
                  {/* <option value='all'>{t("ALL_F")}</option> */}
                  {_.map(dataOptions, (item) => {
                    let id = item.value.getTime().toString(); // ID único pelo timestamp
                    return (
                      <option key={id} value={item.value.toISOString()}>
                        {item.label}
                      </option>
                    );
                  })}
                  
                </Form.Control>
                <label htmlFor="status">{t("CONFIG.DATE")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>

          <Col xs="auto">
            <DropdownButtonExport
                isLoading={isLoading}
                hideCsv={true}
                onClick={(type: string) => {
                  if (checkExportOk())
                  {
                    setLoading(true);
                    let dDash: DatasetModel = DatasetDefault;
                      Object.assign(dDash, getDataSet(selectedDate));
                        FileExportService.ExportWithTermination(
                          dDash,
                          "Dashboard",
                          type,
                          "Repository",
                          moment(selectedDateRef).format("MM-YYYY"),
                          "INDICATOR"
                        );
                  }
                  setLoading(false);
                }}            
              />  
          </Col>
        </Row>
      </Form>     
    </Styles>
    </>
  );
};

export default IndicatorList;
